import {isMobile} from '../../../libs/shared/helpers/src/environment/mobileEnvHelpers';
import {
  getHasDeepPerformanceInstrumentation,
  getHasPerformanceDebugLogging,
  getHasPerformanceMetricLoggingDesktop,
  getHasPerformanceMetricLoggingMobile,
} from '../../../src/store/featureFlags/featureFlagsSelectors';
import {createSelector} from '../../helpers/reselectHelpers';

/** Whether we should include the user in performance metrics. */
export const getHasPerformanceMetricLogging = createSelector(
  [getHasPerformanceMetricLoggingDesktop, getHasPerformanceMetricLoggingMobile],
  (hasPerformanceMetricLoggingDesktop, hasPerformanceMetricLoggingMobile) =>
    isMobile() ? hasPerformanceMetricLoggingMobile : hasPerformanceMetricLoggingDesktop,
);

/** Whether we should enable performance logs for this user. */
export const getHasPerformanceLogging = createSelector(
  [getHasPerformanceMetricLogging, getHasPerformanceDebugLogging],
  (hasPerformanceMetricLogging, hasPerformanceDebugLogging) =>
    hasPerformanceMetricLogging || hasPerformanceDebugLogging,
);

/** Whether we should enable performance logs for this user. */
export const getShouldEnableDeepPerformanceInstrumentation = createSelector(
  [getHasDeepPerformanceInstrumentation, getHasPerformanceLogging],
  (hasDeepPerformanceInstrumentation, hasPerformanceLogging) =>
    hasDeepPerformanceInstrumentation && hasPerformanceLogging,
);
